export default {"src":"/_next/static/media/resources-bg.8f86b036.svg","height":645,"width":1440,"blurWidth":0,"blurHeight":0};